<template>
  <div>Dashboard</div>
</template>

<script>
export default {
  created () {
    // a hack for now, since there is no dashboard yet.
    console.log('here')
    this.$router.replace({name: 'culture'})
  }
}
</script>

<style>

</style>
